import http from "../../http-common";

// Coloplast
const getProductColoplast = (data) => http.post("/LabelPrinting/GetProductColoplast", data);
const getZPLColoplast = (data) => http.post("/LabelPrinting/GetZPLColoplast", data);
const insertZPLColoplast = (data) => http.post("/LabelPrinting/InsertZPLColoplast", data);
const getLabelColoplast = (data) => http.post("/LabelPrinting/GetLabelColoplast", data);

// Ufi
const getLabelUfiData = (data) => http.post("/LabelPrinting/GetLabelUfiData", data);
const insertLabelUfi = (data) => http.post("/LabelPrinting/InsertLabelUfi", data);

//Generic
const getLabelGenericData = (data) => http.post("/LabelPrinting/GetLabelGenericData", data);
const insertLabelGeneric = (data) => http.post("/LabelPrinting/InsertLabelGeneric", data);

//Motul
const getLabelMotulData = (data) => http.post("/LabelPrinting/GetLabelMotulData", data);
const insertLabelMotul = (data) => http.post("/LabelPrinting/InsertLabelMotul", data);
const getProductMotul = (data) => http.post("/Product/GetProductMotul", data);
const getProductMotulByEAN = (ean) => http.get("/Product/GetProductMotulByEAN", {
    params: { ean }
});
const getProductMotulValidate = (data) => http.post("/Product/getProductMotulValidate", data);

export default {
    getProductColoplast,
    getLabelColoplast,
    getZPLColoplast,
    insertZPLColoplast,
    insertLabelUfi,
    getLabelUfiData,
    getLabelGenericData,
    insertLabelGeneric,
    getLabelMotulData,
    insertLabelMotul,
    getProductMotul,
    getProductMotulByEAN,
    getProductMotulValidate
};